const sha1 = require('sha1');
const CryptoJS = require('crypto-js');

export default {
  checkedMobile() {
    if (
      /ipad|iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(
        navigator.userAgent.toLowerCase()
      )
    ) {
      return true;
    }
    return false;
  },
  toSBC(str) {
    let result = '';
    for (let index = 0; index < str.length; index += 1) {
      let cCode = str.charCodeAt(index);
      // 全形與半形相差（除空格外）：65248（十進位制）
      cCode = (cCode >= 0xFF01 && cCode <= 0xFF5E) ? (cCode - 65248) : cCode;
      // 處理空格
      cCode = (cCode === 0x03000) ? 0x0020 : cCode;
      result += String.fromCharCode(cCode);
    }
    return result;
  },
  sha1Password(password) {
    return `*${sha1(sha1(password, { asBytes: true }))}`;
  },
  decryptStringAES(strEncryptText) {
    const key = CryptoJS.enc.Utf8.parse('1111111111111111'); // 需要和伺服器端一致，否則… 無法解密
    const iv = CryptoJS.enc.Utf8.parse('1111111111111111'); // 需要和伺服器端一致，否則… 無法解密
    const decrypted = CryptoJS.AES.decrypt(strEncryptText, key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypted).toString();
  },
  encryptStringAES(strOrignText) {
    const key = CryptoJS.enc.Utf8.parse('1111111111111111'); // 需要和伺服器端一致，否則… 無法解密
    const iv = CryptoJS.enc.Utf8.parse('1111111111111111'); // 需要和伺服器端一致，否則… 無法解密
    const encrypted = CryptoJS.AES.encrypt(strOrignText, key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },
  setModelsToBody(body, state) {
    let id = '';
    let address = {};
    let mobile = {};
    state.models.forEach((element) => {
      const temp = state.answers.find(d => d.id === element.modelID);
      let birthDay = '';
      switch (element.modelID) {
        case 'Address':
          address = temp === undefined ? '' : temp.value;
          if (temp) {
            body.zipCode = parseInt(address.zipCode, 10);
          } else {
            body.zipCode = 0;
          }
          body.country = address.country;
          body.province = address.province;
          body.city = address.city;
          body.district = address.district;
          body.address = address.address;
          break;
        case 'Mobile':
          if (state.mobileData) {
            mobile = state.mobileData;
          } else { mobile = temp === undefined ? '' : temp.value; }
          body.mobileCountry = mobile.mobileCountry.toString();
          body.callingCode = mobile.callingCode.toString();
          body.mobile = mobile.mobile.toString();
          break;
        case 'Name':
          body.realName = temp === undefined ? '' : temp.value;
          break;
        case 'Nickname':
          body.name = temp === undefined ? '' : temp.value;
          break;
        case 'EMail':
          if (state.ssoVersion === 2 && state.trdLoginData) {
            body.email = state.trdLoginData.email;
          } else if (state.accountType === 'Email') {
            body.email = state.accountID;
          } else { body.email = temp === undefined ? '' : temp.value; }
          break;
        case 'Birthday':
          birthDay = temp === undefined ? '' : temp.value;
          if (temp) {
            body.birth = birthDay;
          } else {
            body.birth = '1900-01-01';
          }
          break;
        case 'Password':
          if (!state.trdLoginData) {
            body.password = state.password;
            // 2020.10.29
            // 後續呼叫 put customerdataupdate 修改為v2
            // 該版本的request需有accountType
            body.accountType = state.accountType;
          }
          break;
        case 'PasswordReset':
          if (state.updatePassword) {
            body.password = state.password;
            // 2020.10.29
            // 後續呼叫 put customerdataupdate 修改為v2
            // 該版本的request需有accountType
            body.accountType = state.accountType;
          }
          break;
        default:
          id = element.modelID.substring(0, 1).toLowerCase() + element.modelID.substring(1, element.modelID.length);
          if (temp) {
            body[id] = temp.value;
          }
          break;
      }
    });
    body.custom = [];
    state.customModels.forEach((element) => {
      if (state.customAnswers.find(d => d.customQuestionID === element.customQuestionID)) {
        body.custom.push({
          customQuestionID: element.customQuestionID,
          paramValue: state.customAnswers.find(d => d.customQuestionID === element.customQuestionID).paramValue
        });
      }
    });
  },
  getQueryItem(query) {
    let queryParameter = {
      companyname: query.companyname,
      companyid: query.companyid,
      membersourceid: query.membersourceid,
      redirect_url: query.redirect_url,
      bindingstatus: query.bindingstatus
    };

    if (query.uncheckFriend !== undefined) {
      queryParameter = Object.assign(queryParameter, { uncheckFriend: query.uncheckFriend });
    }

    return queryParameter;
  }
};
